import React from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Table } from '../../../../components';
import Env from '../../../../utils/env';

const ModalViewProductsPromoted = ({ show, onHide, data }) => {
    if (!data) return null;

    return (
        <BModal show={show} onHide={onHide} centered>
            <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                <BModal.Title style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    Productos en la campaña
                </BModal.Title>
            </BModal.Header>
            <BModal.Body style={{ paddingTop: 0, paddingBottom: '30px' }}>
                <p style={{ color: '#666', marginBottom: '20px', marginTop: '10px' }}>
                    A continuación se listan los productos que forman parte de la campaña a promover desde el <strong>{data.start_date.split('-').reverse().join('-')}</strong> hasta el <strong>{data.end_date.split('-').reverse().join('-')}</strong>.
                </p>

                {data.products && data.products.length > 0 ? (
                    <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                        <Table
                            header={['Producto', 'Código']}
                            data={data.products.length}
                            style={{ margin: 0 }}
                        >
                            {data.products.map((item, index) => {
                                const product = item.product || {};
                                return (
                                    <tr key={index}>
                                        <td style={{ verticalAlign: 'middle', fontWeight: '500' }}>
                                            {product.name || 'Producto desconocido'}
                                        </td>
                                        <td style={{ verticalAlign: 'middle', color: '#666' }}>
                                            {product.code || 'N/A'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </Table>
                    </div>
                ) : (
                    <div className="alert alert-info text-center m-0">
                        Esta campaña no tiene productos registrados.
                    </div>
                )}
            </BModal.Body>
        </BModal>
    );
};

export default ModalViewProductsPromoted;
